import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { Info } from '../../../../../core/common';
import { ITestSubCategoryData, ArchitectureDetails, IArchitectureCategory, IArchitectureDetailsBody, IArchitectureSubCategoryBody, ICategoryData, ITestCategoryBody, ITestReportBody, ITestReportDropdownData, ITestReportGrid, ITestCategoryData } from '../../../../../core/models';
import { AdminService } from '../../../../../core/services/admin.service';
import { SuccessEvent, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';

@Component({
  selector: 'app-submittal-package-admin',
  templateUrl: './submittal-package-admin.component.html',
  styleUrls: ['./submittal-package-admin.component.scss']
})
export class SubmittalPackageAdminComponent implements OnInit {

  //#region member variables
  public position = 'top';
  public isTestReportData: boolean;
  architectureDetailsLoading: boolean;
  testReportLoading: boolean;
  architectureDetailsGridView: GridDataResult;
  testReportGridView: GridDataResult;
  architectureCategoryForm: FormGroup;
  architectureDetailsForm: FormGroup;
  architectureSubCategoryForm: FormGroup;
  testReportForm: FormGroup;
  testCategoryForm: FormGroup;
  categoryData: ICategoryData[];
  selectedCategory: string = "";
  selectedCategoryId: string;
  categorySaveInProcess: boolean;
  subCategorySaveInProcess: boolean;
  architectureSubCategorySaveInProcess: boolean;
  testCategorySaveInProcess: boolean;
  testReportsaveInProcess: boolean;
  architectureSubCategoryData: ITestReportDropdownData[];
  testCategoryData: ITestCategoryData[];
  SubCategoryDataList: any;
  selectedSubCategory: string = "";
  selectedTestCategory: string = "";
  selectedTestCategoryId: string;
  selectedSubCategoryId: string;
  testSubCategoryData: ITestSubCategoryData[];
  selectedTestSubCategory: string;
  selectedTestSubCategoryId: string;

  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;

  fileToUpload: File = null;
  fileToUploadTestReport: File = null;

  filePath: string;
  fileTestReportPath: string;
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".pdf"],
  };
  subCategoryUpload: string = "";
  testReportUpload: string = "";
  //#endregion
  constructor(private adminService: AdminService, private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService,

  ) { }

  ngOnInit() {
    this.architecturalDetailsFormInit();
    this.testReportFormInit();
    this.loadArchitectureDetailsGrid();
    this.adminService.getCategory().subscribe((response) => { // needs to Create function for this written two times
      this.categoryData = response as ICategoryData[];
    });
    this.isTestReportData = false;
    this.architectureSubCategoryData = [] as ITestReportDropdownData[];
    this.testCategoryData = [] as ITestCategoryData[];
    this.testSubCategoryData = [] as ITestSubCategoryData[];
  }
  //#region Initialize form controls
  architecturalDetailsFormInit() {
    this.architectureCategoryForm = this.formBuilder.group({
      categoryId: new FormControl(""),
      categoryDescription: new FormControl(""),
      isCategoryActive: new FormControl()
    })
    this.architectureDetailsForm = this.formBuilder.group({
      subCategoryId: new FormControl(""),
      category: new FormControl(""),
      subCategory: new FormControl(""),
      isActive: new FormControl(),
      fileUpload: new FormControl(""),
    })
  }
  testReportFormInit() {
    this.architectureSubCategoryForm = this.formBuilder.group({
      subCategoryId: new FormControl(""),
      architectureSubCategory: new FormControl(""),
      testCategory: new FormControl(""),
      testSubCategory: new FormControl(),
      isArchitectureSubCategoryActive: new FormControl(),
    })
    this.testCategoryForm = this.formBuilder.group({
      testCategoryId: new FormControl(""),
      subCategoryId: new FormControl(""),
      subCategoryDescription: new FormControl(""),
      testCategoryDescription: new FormControl(""),
      isTestCategoryActive: new FormControl(),

    })
    this.testReportForm = this.formBuilder.group({
      subCategoryId: new FormControl(""),
      architectureSubCategory: new FormControl(""),
      testCategory: new FormControl(""),
      testSubCategory: new FormControl(""),
      testType: new FormControl(""),
      testDescription: new FormControl(""),
      reportNumber: new FormControl(""),
      ecNumber: new FormControl(""),
      ecVersion: new FormControl(""),
      isTestReportTypeActive: new FormControl(),
      testReportId: new FormControl(),
      testReportfileUpload: new FormControl(""),
      //files: new FormControl(""),
    })
  }
  //#endregion

  //#region kendo upload
  subCategoryImageSelected(evt: SelectEvent) {

  }
  subCategoryUploadSuccess(evt: SuccessEvent) {
    this.subCategoryUpload = evt.response.body.paths[0];
  }
  //#endregion
  //#region save success label common code
  initilizeSuccessLabel() {
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
  }

  //#endregion
  //#region Architecture details tab pane operations

  //#region category
  //#region Grid data binding
  public loadArchitectureDetailsGrid(): void {
    this.architectureDetailsLoading = true;
    this.adminService.getArchitectureDetails().subscribe((response) => {
      this.bindArchitectureDetailsGrid();
      this.architectureDetailsLoading = false;
    });
  }
  //#endregion
  //#region pagination, sorting,filtering for grid

  public architectureDetailsGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'categoryId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindArchitectureDetailsGrid(): void {
    const data = this.adminService.architectureDetails;
    this.architectureDetailsGridView = process(data, this.architectureDetailsGridstate);
  }

  public architectureDetailsGridSortChange(sort: SortDescriptor[]): void {
    this.architectureDetailsGridstate.sort = sort;
    this.bindArchitectureDetailsGrid();
  }
  public architectureDetailsGridPageChange({ skip, take }: PageChangeEvent): void {
    this.architectureDetailsGridstate.skip = skip;
    this.architectureDetailsGridstate.take = take;
    this.bindArchitectureDetailsGrid();
  }

  public architectureDetailsDataStateChange(state: DataStateChangeEvent): void {
    this.architectureDetailsGridstate = state;
    this.bindArchitectureDetailsGrid();
  }
  //#endregion

  //#region Category label and variable declaration
  architectureCategory = {
    categoryLbl: "Category",
    isCategoryActiveLbl: "IsActive",
    isEmptyCategoryDescription: false,
    isSubmitted: false,
  }
  //#endregion

  //#region architecture category dialog operations

  architectureCategoryDialog = {
    opened: false,
  }
  toggleArchitectureCategoryDialog() {
    this.architectureCategoryDialog.opened = !this.architectureCategoryDialog.opened;
    //if (this.architectureCategoryDialog.opened == false) {
      this.resetArchitectureCategoryForm();
   // }
  }

  //#endregion

  resetArchitectureCategoryForm() {
    this.architectureCategory.isSubmitted = false;
    this.architectureCategoryForm.reset();
    this.architectureCategory.isEmptyCategoryDescription = false;
    this.infoMessage = new Info();
    this.categorySaveInProcess = false;
    this.architectureCategoryForm.controls.isCategoryActive.setValue(true);
  }


  public validateArchitectureCategoryForm(): boolean {
    let isValid = true;
    const controls = this.architectureCategoryForm.controls;
    if (this.architectureCategory.isSubmitted) {
      if (controls.categoryDescription.value) {
        this.architectureCategory.isEmptyCategoryDescription = false;
      } else {
        this.architectureCategory.isEmptyCategoryDescription = true;
        isValid = false;
      }

    }
    return isValid;
  }
  saveArchitectureCategory() {
    this.architectureCategory.isSubmitted = true;
    if (!this.validateArchitectureCategoryForm()) {
      return;
    }
    this.initilizeSuccessLabel();
    this.categorySaveInProcess = true;
    var controls = this.architectureCategoryForm.controls
    //const body: IArchitectureCategory = { //  change interface class to return common result
    //  categoryId: controls.categoryId.value,
    //  categoryDescription: controls.categoryDescription.value,
    //  IsCategoryActive: controls.isCategoryActive.value ? controls.isCategoryActive.value : false
    //}

    const body: IArchitectureDetailsBody = {
      categoryId: controls.categoryId.value,
      categoryDescription: controls.categoryDescription.value,
      isActive: controls.isCategoryActive.value ? controls.isCategoryActive.value : false,
      subCategoryDescription: "",
      subCategoryId: "",
      urlPath: "",

    }
    this.adminService.saveArchitectureCategory(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.categorySaveInProcess = false;
      if (response) {
        this.resetArchitectureCategoryForm();
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.bindArchitectureDetailsGrid();
      }
      else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }

    })
  }
  //#endregion

  //#region sub category
  //#region Sub Category label and variable declaration
  architectureDetails = {
    categoryLbl: "Category",
    subCategoryLbl: "Sub Category",
    urlLbl: "Url",
    uploadLbl: "File Upload",
    isActiveLbl: "IsActive",
    actionLbl: "Action",
    isEmptyCategory: false,
    isEmptySubCategory: false,
    isEmptyUpload: false,
    isSubmitted: false,
  }

  //#endregion
  //#region architecture details dialog operations

  architectureDetailsDialog = {
    opened: false,
  }
  toggleArchitectureDetailsDialog() {
    this.architectureDetailsDialog.opened = !this.architectureDetailsDialog.opened;
    this.adminService.getCategory().subscribe((response) => {
      this.categoryData = response as ICategoryData[];
    });
    //if (this.architectureDetailsDialog.opened == false) {
      this.resetArchitectureDetailsForm();

    //}
  }
  //Need to varify edit operation for add category 
  editArchitectureDetails(data: ArchitectureDetails) {
    if (data.subCategoryDescription) {
      this.architectureDetailsDialog.opened = !this.architectureDetailsDialog.opened;
      this.architectureDetailsForm.controls.subCategoryId.setValue(data.subCategoryId);
      this.selectedCategory = data.categoryDescription;
      this.selectedCategoryId = data.categoryId;
      this.architectureDetailsForm.controls.subCategory.setValue(data.subCategoryDescription);
      this.architectureDetailsForm.controls.isActive.setValue(data.isActive);
      this.filePath = data.urlPath;
      this.subCategoryUpload = data.urlPath;

    } else {
      this.architectureCategoryDialog.opened = !this.architectureCategoryDialog.opened;
      this.architectureCategoryForm.controls.categoryId.setValue(data.categoryId);
      this.architectureCategoryForm.controls.categoryDescription.setValue(data.categoryDescription);
      this.architectureCategoryForm.controls.isCategoryActive.setValue(data.subCategoryId)
    }
  }
  
  resetArchitectureDetailsForm() {
    this.architectureDetails.isSubmitted = false;
    this.architectureDetailsForm.reset();
    this.architectureDetails.isEmptyCategory = false;
    this.architectureDetails.isEmptySubCategory = false;
    this.infoMessage = new Info();
    this.subCategorySaveInProcess = false;
    this.selectedCategory = "";
    this.selectedCategoryId = "";
    this.fileToUpload = null;
    this.architectureDetailsForm.controls.isActive.setValue(true);
    this.filePath = "";
    this.subCategoryUpload= "";
  }

  public validateArchitectureDetailsForm(): boolean {
    let isValid = true;
    const controls = this.architectureDetailsForm.controls;
    if (this.architectureDetails.isSubmitted) {
      if (controls.category.value.categoryDescription) {
        this.architectureDetails.isEmptyCategory = false;
      } else {
        this.architectureDetails.isEmptyCategory = true;
        isValid = false;
      }
      if (controls.subCategory.value) {
        this.architectureDetails.isEmptySubCategory = false;
      } else {
        this.architectureDetails.isEmptySubCategory = true;
        isValid = false;
      }
      //add here for file upload

    }
    return isValid;
  }  

  saveArchitectureSubCategory() {
    this.architectureDetails.isSubmitted = true;
    if (!this.validateArchitectureDetailsForm()) {
      return;
    }
    this.subCategorySaveInProcess = true;
    this.initilizeSuccessLabel();
    var controls = this.architectureDetailsForm.controls;
    const body: IArchitectureDetailsBody = {
      categoryId: controls.category ? controls.category.value.categoryId.toString() : "",
      subCategoryId: controls.subCategoryId ? controls.subCategoryId.value:0,
      categoryDescription: controls.category ? controls.category.value.categoryDescription : "",
      subCategoryDescription: controls.subCategory.value,
      urlPath: this.subCategoryUpload,
      isActive: controls.isActive.value ? controls.isActive.value : false
    }
    //old code 
    //const formData = new FormData();
    //formData.append('categoryId', body.categoryId);
    //formData.append('subCategoryId', body.subCategoryId);
    //formData.append('categoryDescription', body.categoryDescription);
    //formData.append('subCategoryDescription', body.subCategoryDescription);
    //formData.append('urlPath', this.filePath);
    //formData.append("isActive", controls.isActive.value ? controls.isActive.value : false);
    //if (this.fileToUpload != null) {
    //  formData.append('file', this.fileToUpload, this.fileToUpload ? this.fileToUpload.name : "");
    //}
    //else {
    //  formData.append('file', "");

    //}

    this.adminService.saveArchitectureDetails(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.subCategorySaveInProcess = false;

      if (response) {
          this.resetArchitectureDetailsForm();
          this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.bindArchitectureDetailsGrid();
        } else {
          this.infoMessage.genericError = this.infoMessage.errorMessage;
        }
      })
  }
  //#endregion 
  //#endregion
  //#region details grid tab select Api call
  onTabSelected(event) {
    if (event.index == 1) {
      if (this.isTestReportData == false) {
        this.loadTestReportGrid();
      }
    }
  }
  //#endregion
  //#region Test report tab pane operations
  //#region Grid data binding
  public loadTestReportGrid(): void {
    this.testReportLoading = true;
    this.adminService.getTestReport().subscribe((response) => {
      this.bindTestReportGrid();
      this.testReportLoading = false;
      this.isTestReportData = true;
    });
  }
  //#endregion
  //#region pagination, sorting,filtering for grid

  public testReportGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'subCategoryId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindTestReportGrid(): void {
    const data = this.adminService.testReportData;
    this.testReportGridView = process(data, this.testReportGridstate);
  }

  public testReportGridSortChange(sort: SortDescriptor[]): void {
    this.testReportGridstate.sort = sort;
    this.bindTestReportGrid();
  }
  public testReportGridPageChange({ skip, take }: PageChangeEvent): void {
    this.testReportGridstate.skip = skip;
    this.testReportGridstate.take = take;
    this.bindTestReportGrid();
  }

  public testReportDataStateChange(state: DataStateChangeEvent): void {
    this.testReportGridstate = state;
    this.bindTestReportGrid();
  }
  //#endregion

  //#region Architecture sub category
  //#region Architecture Sub Category label and variable declaration
  architectureSubCategory = {

    architectureSubCategoryLbl: "Architecture Sub Category",
    testCategoryLbl: "Test Category",
    testSubCategoryLbl: "Test Sub Category",
    isArchitectureSubCategoryActiveLbl: "IsActive",
    isEmptyArchitectureSubCategory: false,
    isEmptyTestCategory: false,
    isEmptyTestSubCategory: false,
    isSubmitted: false,
  }
  //#endregion

  //#region architecture sub category dialog operations

  architectureSubCategoryDialog = {
    opened: false,
  }
  toggleArchitectureSubCategoryDialog() {
    this.architectureSubCategoryDialog.opened = !this.architectureSubCategoryDialog.opened;
    if (this.architectureSubCategoryDialog.opened == true) {
      this.bindArchitectureSubCategoryDropdown();
    } else {
      this.resetArchitectureSubCategoryForm();
    }
    this.architectureSubCategoryForm.controls.isArchitectureSubCategoryActive.setValue(true);
  }

  //#endregion

  resetArchitectureSubCategoryForm() {
    this.architectureSubCategory.isSubmitted = false;
    this.architectureSubCategoryForm.reset();
    this.architectureSubCategory.isEmptyArchitectureSubCategory = false;
    this.architectureSubCategory.isEmptyTestCategory = false;
    this.architectureSubCategory.isEmptyTestSubCategory = false;
    this.infoMessage = new Info();
    this.architectureSubCategorySaveInProcess = false;
    this.architectureSubCategoryForm.controls.isArchitectureSubCategoryActive.setValue(true);

  }

  public validateArchitectureSubCategoryForm(): boolean {
    let isValid = true;
    const controls = this.architectureSubCategoryForm.controls;
    if (this.architectureSubCategory.isSubmitted) {
      const t = controls.architectureSubCategory.value ? controls.architectureSubCategory.value.subCategoryDescription : "";
      if (t) {
        this.architectureSubCategory.isEmptyArchitectureSubCategory = false;
      } else {
        this.architectureSubCategory.isEmptyArchitectureSubCategory = true;
        isValid = false;
      }
      const p = controls.testCategory.value ? controls.testCategory.value.testCategoryDescription : "";
      if (p) {
        this.architectureSubCategory.isEmptyTestCategory = false;
      } else {
        this.architectureSubCategory.isEmptyTestCategory = true;
        isValid = false;
      }
      //if (controls.architectureSubCategoryDescription.value) { // need to check this validation
      //  this.architectureSubCategory.isEmptyArchitectureSubCategory = false;
      //} else {
      //  this.architectureSubCategory.isEmptyArchitectureSubCategory = true;
      //  isValid = false;
      //}

      if (controls.testSubCategory.value) {
        this.architectureSubCategory.isEmptyTestSubCategory = false;
      } else {
        this.architectureSubCategory.isEmptyTestSubCategory = true;
        isValid = false;
      }
    }
    return isValid;
  }
  saveTestSubCategory() {
    this.architectureSubCategory.isSubmitted = true;
    if (!this.validateArchitectureSubCategoryForm()) {
      return;
    }
    this.architectureSubCategorySaveInProcess = true;
    this.initilizeSuccessLabel();
    var controls = this.architectureSubCategoryForm.controls;
    //Add dropdown controls data here
    const body: ITestReportBody = {
      // subCategoryId: controls.subCategoryId.value,
      //architectureSubCategoryDescription: controls.architectureSubCategoryDescription.value,

      subCategoryId: controls.architectureSubCategory.value ? controls.architectureSubCategory.value.subCategoryId : "",
      subCategoryDescription: controls.architectureSubCategory.value ? controls.architectureSubCategory.value.subCategoryDescription : "",
      testCategoryId: controls.testCategory.value ? controls.testCategory.value.testCategoryId : "",
      testCategoryDescription: controls.testCategory.value ? controls.testCategory.value.testCategoryDescription : "",
      testSubCategoryDescription: controls.testSubCategory.value,
      isActive: controls.isArchitectureSubCategoryActive.value ? controls.isArchitectureSubCategoryActive.value : false,
      ecNumber: "",
      ecVersion: "",
      testReportDescription: "",
      testReportNumber: "",
      testSubCategoryId: "",
      testType: "",
      urlPath: "",
      testReportId: 0
    }
    this.adminService.saveTestSubCategory(body).subscribe((response: any) => {
      this.architectureSubCategorySaveInProcess = false;
      this.infoMessage.genericInProgress = "";
      if (response) {
        this.resetArchitectureSubCategoryForm();
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.loadTestReportGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
    })
  }

  //#endregion
  //#region Test category
  //#region Test Category label and variable declaration
  testCategory = {
    architectureSubCategoryLbl: "Architecture Sub Category",
    testCategory: "Test Category",
    isTestCategoryActiveLbl: "IsActive",
    isEmptyArchitectureSubCategory: false,
    isEmptyTestCategory: false,
    isSubmitted: false,
  }
  //#endregion

  //#region test category dialog operations
  testCategoryDialog = {
    opened: false,
  }
  toggleTestCategoryDialog() {
    this.testCategoryDialog.opened = !this.testCategoryDialog.opened;
    if (this.testCategoryDialog.opened == true) {
      this.bindArchitectureSubCategoryDropdown();
    } else {
      this.resetTestCategoryForm();
    }

    this.testCategoryForm.controls.isTestCategoryActive.setValue(true);  
  }


  resetTestCategoryForm() {
    this.testCategory.isSubmitted = false;
    this.testCategoryForm.reset();
    this.testCategory.isEmptyArchitectureSubCategory = false;
    this.testCategory.isEmptyTestCategory = false;
    this.testCategorySaveInProcess = false;
    this.infoMessage = new Info();
    this.testCategoryForm.controls.isTestCategoryActive.setValue(true);  

  }

  public validateTestCategoryForm(): boolean {
    let isValid = true;
    const controls = this.testCategoryForm.controls;
    if (this.testCategory.isSubmitted) {
      const t = controls.subCategoryDescription.value ? controls.subCategoryDescription.value.subCategoryDescription : "";
      if (t) {
        this.testCategory.isEmptyArchitectureSubCategory = false;
      } else {
        this.testCategory.isEmptyArchitectureSubCategory = true;
        isValid = false;
      }
      if (controls.testCategoryDescription.value) {
        this.testCategory.isEmptyTestCategory = false;
      } else {
        this.testCategory.isEmptyTestCategory = true;
        isValid = false;
      }
    }
    return isValid;
  }
  saveTestCategory() {
    this.testCategory.isSubmitted = true;
    if (!this.validateTestCategoryForm()) {
      return;
    }
    this.testCategorySaveInProcess = true;
    this.initilizeSuccessLabel();
    var controls = this.testCategoryForm.controls
    const body: ITestCategoryBody = {
      testCategoryId: controls.testCategoryId.value,
      subCategoryId: controls.subCategoryDescription.value ? controls.subCategoryDescription.value.subCategoryId : "",
      subCategoryDescription: controls.subCategoryDescription.value ? controls.subCategoryDescription.value.subCategoryDescription : "",
      testCategoryDescription: controls.testCategoryDescription.value,
      isActive: controls.isTestCategoryActive.value ? controls.isTestCategoryActive.value : false,
      testSubCategoryId: "",
      testSubCategoryDescription: "",
      testType: "",
      testReportDescription: "",
      testReportNumber: "",
      ecNumber: "",
      ecVersion: "",
      urlPath: "",
      testReportId: 0
    }
    this.adminService.saveTestCategory(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.testCategorySaveInProcess = false;
      if (response) {
        this.resetTestCategoryForm();

        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.loadTestReportGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;

      }

    })
  }

  //#endregion
  //#region Test Report
  //#region kendo upload
  testReportImageSelected(evt: SelectEvent) {

  }
  testReportUploadSuccess(evt: SuccessEvent) {
    this.testReportUpload = evt.response.body.paths[0];
  }
  //#endregion
  //#region label and variable declaration
  testReportLbl = {
    architectureSubCategory: "Architecture Sub Category",
    testCategory: "Test Category",
    testSubCategory: "Test Sub Category",
    testType: "Test Type",
    testDescription: "Test Description",
    reportNumber: "Report Number",
    ecNumber: "Ec Number",
    ecVersion: "Ec Version",
    url: "Url",
    uploadUrl: "Upload",
    isActive: "IsActive",
    action: "Action",
    isEmptyArchitectureSubCategory: false,
    isEmptyTestCategory: false,
    isEmptyTestSubCategory: false,
    isEmptyTestType: false,
    isEmptytestDescription: false,
    isEmptyReportNumber: false,
    isEmptyECNumber: false,
    isEmptyECVersion: false,
    isSubmitted: false

  }
  //#endregion
  //#region test report test type dialog
  testReportDialog = {
    opened: false,
  }
  toggleTestReportDialog() {
    this.testReportDialog.opened = !this.testReportDialog.opened;
    //binding architecture sub category dropdown on dialog open
    if (this.testReportDialog.opened == true) {
      this.bindArchitectureSubCategoryDropdown();
    } else {
      this.resetTestReportTypeForm();
    }

    this.testReportForm.controls.isTestReportTypeActive.setValue(true);  
  }
  bindArchitectureSubCategoryDropdown() {
    let filterArray = this.adminService.testReportData;
    filterArray = filterArray.filter((v, i, a) => a.findIndex(t => (t.subCategoryId === v.subCategoryId)) === i);
    this.architectureSubCategoryData = filterArray as ITestReportDropdownData[];
  }
  editTestReport(data: ITestReportGrid) {
    this.testReportDialog.opened = !this.testReportDialog.opened;
    if (this.testReportDialog.opened == true) {
      //set values to form control
      this.bindArchitectureSubCategoryDropdown();



      this.testReportForm.controls.testReportId.setValue(data.testReportId);


      this.selectedSubCategory = data.subCategoryDescription;
      this.selectedSubCategoryId = data.subCategoryId;
      this.selectedTestCategory = data.testCategoryDescription;
      this.selectedTestCategoryId = data.testCategoryId;
      this.selectedTestSubCategory = data.testSubCategoryDescription;
      this.selectedTestSubCategoryId = data.testSubCategoryId;

      this.testReportForm.controls.testType.setValue(data.testType);
      this.testReportForm.controls.testDescription.setValue(data.testReportDescription);
      this.testReportForm.controls.reportNumber.setValue(data.testReportNumber);
      this.testReportForm.controls.ecNumber.setValue(data.ecNumber);
      this.testReportForm.controls.ecVersion.setValue(data.ecVersion);
      this.testReportForm.controls.isTestReportTypeActive.setValue(data.isActive);

      this.fileTestReportPath = data.urlPath;
      this.testReportUpload = data.urlPath;

    } else {
      //reset
    }
  }
  architectureSubCategoryChange(event) {
    let filterArray = this.adminService.testReportData;
    let tempArray = filterArray.filter(f => f.subCategoryId == event.subCategoryId);
    tempArray = tempArray.filter((v, i, a) => a.findIndex(t => (t.testCategoryId === v.testCategoryId)) === i);
    this.testCategoryData = tempArray as ITestCategoryData[];

  }

  testCategoryChange(event) {
    let filterArray = this.adminService.testReportData;
    let tempArray = filterArray.filter(f => f.testCategoryId == event.testCategoryId);
    tempArray = tempArray.filter((v, i, a) => a.findIndex(t => (t.testSubCategoryId === v.testSubCategoryId)) === i);
    this.testSubCategoryData = tempArray as ITestSubCategoryData[];

  }

  public validateTestReportTypeForm(): boolean {
    let isValid = true;
    const controls = this.testReportForm.controls;
    if (this.testReportLbl.isSubmitted) {
      const t = controls.architectureSubCategory.value ? controls.architectureSubCategory.value.subCategoryDescription : "";
      if (t) {
        this.testReportLbl.isEmptyArchitectureSubCategory = false;
      } else {
        this.testReportLbl.isEmptyArchitectureSubCategory = true;
        isValid = false;
      }
      const p = controls.testCategory.value ? controls.testCategory.value.testCategoryDescription : "";
      if (p) {
        this.testReportLbl.isEmptyTestCategory = false;
      } else {
        this.testReportLbl.isEmptyTestCategory = true;
        isValid = false;
      }
      const s = controls.testSubCategory.value ? controls.testSubCategory.value.testSubCategoryDescription : "";
      if (s) {
        this.testReportLbl.isEmptyTestSubCategory = false;
      } else {
        this.testReportLbl.isEmptyTestSubCategory = true;
        isValid = false;
      }
      if (controls.testType.value) {
        this.testReportLbl.isEmptyTestType = false;
      } else {
        this.testReportLbl.isEmptyTestType = true;
        isValid = false;
      }

      if (controls.testDescription.value) {
        this.testReportLbl.isEmptytestDescription = false;
      } else {
        this.testReportLbl.isEmptytestDescription = true;
        isValid = false;
      }

      if (controls.reportNumber.value) {
        this.testReportLbl.isEmptyReportNumber = false;
      } else {
        this.testReportLbl.isEmptyReportNumber = true;
        isValid = false;
      }

      if (controls.ecNumber.value) {
        this.testReportLbl.isEmptyECNumber = false;
      } else {
        this.testReportLbl.isEmptyECNumber = true;
        isValid = false;
      }

      if (controls.ecVersion.value) {
        this.testReportLbl.isEmptyECVersion = false;
      } else {
        this.testReportLbl.isEmptyECVersion = true;
        isValid = false;
      }


    }
    return isValid;
  }
  resetTestReportTypeForm() {
    this.testReportLbl.isSubmitted = false;
    this.testReportForm.reset();
    this.testReportLbl.isEmptyArchitectureSubCategory = false;
    this.testReportLbl.isEmptyTestCategory = false;
    this.testReportLbl.isEmptyTestSubCategory = false;
    this.testReportLbl.isEmptyTestType = false;
    this.testReportLbl.isEmptytestDescription = false;
    this.testReportLbl.isEmptyReportNumber = false;
    this.testReportLbl.isEmptyECNumber = false;
    this.testReportLbl.isEmptyECVersion = false;
    this.testReportsaveInProcess = false;
    this.infoMessage = new Info();


    this.selectedSubCategory = "";
    this.selectedSubCategoryId = "";
    this.selectedTestCategory = "";
    this.selectedTestCategoryId = "";
    this.selectedTestSubCategory = "";
    this.selectedTestSubCategoryId = "";
    this.fileToUploadTestReport = null;
    this.testReportForm.controls.isTestReportTypeActive.setValue(true);
    this.fileTestReportPath = "";
    this.testReportUpload = "";
  }

  

  saveTestReport() {
    this.testReportLbl.isSubmitted = true;
    if (!this.validateTestReportTypeForm()) {
      return;
    }
    this.testReportsaveInProcess = true;
    this.initilizeSuccessLabel();

    var controls = this.testReportForm.controls
    const body: ITestReportBody = {

      subCategoryId: controls.architectureSubCategory.value ? controls.architectureSubCategory.value.subCategoryId : "",
      subCategoryDescription: controls.architectureSubCategory.value ? controls.architectureSubCategory.value.subCategoryDescription : "",
      testCategoryId: controls.testCategory.value ? controls.testCategory.value.testCategoryId : "",
      testCategoryDescription: controls.testCategory.value ? controls.testCategory.value.testCategoryDescription : "",
      testSubCategoryId: controls.testSubCategory.value ? controls.testSubCategory.value.testSubCategoryId : "",
      testSubCategoryDescription: controls.testSubCategory.value ? controls.testSubCategory.value.testSubCategoryDescription : "",
      testType: controls.testType.value,
      testReportDescription: controls.testDescription.value,
      testReportNumber: controls.reportNumber.value,
      ecNumber: controls.ecNumber.value,
      ecVersion: controls.ecVersion.value,
      isActive: controls.isTestReportTypeActive.value ? controls.isTestReportTypeActive.value : false,
      urlPath: this.testReportUpload,
      testReportId: controls.testReportId.value ? controls.testReportId.value : 0
    }
    //const formData = new FormData();
    //if (this.fileToUploadTestReport != null) {
    //  formData.append('file', this.fileToUploadTestReport, this.fileToUploadTestReport ? this.fileToUploadTestReport.name : "");
    //}
    //else {
    //  formData.append('file', "");

    //}
    //formData.append('subCategoryId', body.subCategoryId);
    //formData.append('subCategoryDescription', body.subCategoryDescription);
    //formData.append('testCategoryId', body.testCategoryId);
    //formData.append('testCategoryDescription', body.testCategoryDescription);
    //formData.append('testSubCategoryId', body.testSubCategoryId);
    //formData.append('testSubCategoryDescription', body.testSubCategoryDescription);
    //formData.append('testType', body.testType);
    //formData.append('testReportDescription', body.testReportDescription);
    //formData.append('testReportNumber', body.testReportNumber);
    //formData.append('ecNumber', body.ecNumber);
    //formData.append('ecVersion', body.ecVersion);
    //formData.append('isActive', controls.isTestReportTypeActive.value ? controls.isTestReportTypeActive.value : false);
    //formData.append('testReportId', controls.testReportId.value ? controls.testReportId.value : 0);
    //formData.append('urlPath', this.fileTestReportPath);

    this.adminService.saveTestReport(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.testReportsaveInProcess = false;
      if (response) {
        this.resetTestReportTypeForm();

        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.loadTestReportGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
    })
  }
  //#endregion
  //#endregion
  //#endregion
  //#endregion


  //#region delete sub category
  public type: string;
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem,type): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    this.type = type;
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      if (this.type == "SubCategory") {
        this.SubCategoryRemoveHandler();
      }
      else if (this.type == "TestReport") {
        this.TestReportRemoveHandler();
      }
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
      this.type = "";
    }
  }
  public SubCategoryRemoveHandler() {
    this.adminService.deleteArchitectureDetails(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const subCategoryId = this.gridItemToRemove.subCategoryId;
      this.gridItemToRemove = null;
      this.type = "";

      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected sub category has been removed.");

      if (this.adminService.architectureDetails) {
        //This is a Local Remove
        const index = (this.adminService.architectureDetails).findIndex(r => r.subCategoryId === subCategoryId);
        (this.adminService.architectureDetails).splice(index, 1);
        this.bindArchitectureDetailsGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  public TestReportRemoveHandler() {
    this.adminService.deleteTestReport(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const testReportId = this.gridItemToRemove.testReportId;
      this.gridItemToRemove = null;
      this.type = "";

      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected test report has been removed.");

      if (this.adminService.testReportData) {
        //This is a Local Remove
        const index = (this.adminService.testReportData).findIndex(r => r.testReportId === testReportId);
        (this.adminService.testReportData).splice(index, 1);
        this.bindTestReportGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
